import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { FlexGrid, DataMap, DataMapEditor } from '@grapecity/wijmo.grid';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW7401Model } from './kymw7401.model';
import { GetCandidateGoodsListService } from './api-service/get-candidate-goods-list.service';
import { KYMW7401OutputModel } from './vo/kymw7401-output.model';
import { KYMW0300InputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-input.model';
import { KYMW0300OutputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-output.model';
import { KYMW0300Component } from '../../../commons/kymw03/kymw0300/kymw0300.component';

import type { CandidateGoodsInfo, RadioValue } from './vo/goods-info.model';
import { KYMW0300Model } from '../../../commons/kymw03/kymw0300/kymw0300.model';

@Component({
  selector: 'app-kymw7401',
  templateUrl: './kymw7401.component.html',
  styleUrls: ['./kymw7401.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW7401Component extends PlessViewHelperSub implements OnInit, AfterViewInit {
  model = new KYMW7401Model();
  // 親画面への連携用
  setKYMW7401Parameter: Function;
  // ラジオボタン用データマップ
  dataMapEditor = DataMapEditor.RadioButtons;
  dataMap = new DataMap<{val: RadioValue; name: string}, RadioValue>(
    [{ val: "1", name: "" }],
    'val',
    'name'
  );
  private output: KYMW7401OutputModel = {};
  private kymw0300InputModel: KYMW0300InputModel = null; // 商品検索画面のモデル
  private kymw0300Model: KYMW0300Model = new KYMW0300Model();

  @ViewChild('dtg_GoodsList', { static: true }) dtg_GoodsList: FlexGrid;

  constructor(
    private kymw00Model: KYMW00Model,
    private dialogService: PlessDialogServiceSub,
    private service: GetCandidateGoodsListService,
  ) {
    super(kymw00Model);
  }

  ngOnInit() { }

  ngAfterViewInit() {
    // ラジオボタン付きグリッドデータ制御
    this.dtg_GoodsList.selectionChanged.addHandler((sender, eventArgs) => {
      const selectedRow = sender.selection.row;
      if (selectedRow >= 0) {
        const selectedItem = sender.rows[selectedRow].dataItem as CandidateGoodsInfo;
        selectedItem.selected = "1";  // 選択行のフラグを選択状態に
        this.setOutput(selectedItem); // 出力用にセット

        // 他の行の選択状態を解除
        sender.itemsSource.forEach((rowItem: CandidateGoodsInfo, rowIdx: number) => {
          if (rowIdx !== selectedRow) {
            rowItem.selected = ""; // 未選択状態の値をセット
          }
        });

        // グリッドを再描画
        sender.invalidate();
      }
    });
  }

  /**  商品検索ボタン クリック時処理 */
  eventSearchGoods_CLICKHandler() {
    // KYMW0300 商品検索ダイアログ用のインプットモデル生成（初回表示時のみ初期化）
    if (!this.kymw0300InputModel) {
      this.kymw0300InputModel = new KYMW0300InputModel();
    }

    this.kymw0300InputModel.catalogSearchFlg = 0;       // 企画検索表示フラグ(0: 表示しない)

    // 商品検索画面をモーダルで表示
    const componentRef = this.dialogService.openModal(KYMW0300Component);
    const instance = componentRef.componentInstance as KYMW0300Component;
    instance.parent = this;
    instance.setInterfaceParam(this.kymw0300InputModel); // 最後に保持した検索条件をセット
    // 「候補リスト作成」ボタン押下時処理
    instance.setKYMW0300Parameter = (kymw0300OutputModel: KYMW0300OutputModel) => {
      this.kymw0300InputModel = this.kymw0300Model.getKYMW0300SearchHistory(kymw0300OutputModel);

      // 商品一覧初期化
      this.model.candidateGoodsList = [] as CandidateGoodsInfo[];

      // 商品検索項目 kymw0300OutputModel をリクエストに渡す
      this.getCandidateGoodsList(kymw0300OutputModel);
    };
    // ダイアログ閉じるアイコンボタン押下時処理
    instance.closeFunction = () => componentRef.close();
  }

  // 「閉じる」ボタン押下時処理
  eventClose_CLICKHandler(): void {
    this.closeWindow(true);
  }

  // 「登録商品として使用」ボタン押下時処理
  eventSelect_CLICKHandler(): void {
    if (this.output.selectedGoodsInfo) {
      // 選択した対象商品情報を渡す
      this.setKYMW7401Parameter(this.output);
      this.closeWindow(true);
    } else {
      // 「忘れず注文商品対象 が選択されていません」
      this.dialogService.openAlertGetMessage('E0103', ['忘れず注文商品対象']);
    }
  }

  // 候補商品一覧情報 取得
  private getCandidateGoodsList(request: KYMW0300OutputModel): void {
    // APIリクエスト
    this.service.execute(this.model, request, (response) => {
        // 取得データをリストに追加する
        const newCandidateGoodsList: CandidateGoodsInfo[] = response.CandidateGoodsList.map(_ => {
          return {
            selected: "",
            itemCode: _.ItemCode,
            pCode: _.PCode,
            classCode: _.ClassCode,
            className: _.ClassName,
            buyerCode: _.BuyerCode,
            buyerName: _.BuyerName,
            guideGoodsName:_.GuideGoodsName,
            guideStandardName: _.GuideStandardName,
            makerName: _.MakerName,
            payeeClientCode: _.PayeeClientCode,
            payeeClientKanji: _.PayeeClientKanji,
            regularRegistDate: _.RegularRegistDate,
          };
        });

        // 一覧表示
        this.model.candidateGoodsList = newCandidateGoodsList;
    });
  }

  // 選択されたデータを出力用モデルにセットする
  private setOutput(goodsInfo: CandidateGoodsInfo): void {
    if (goodsInfo.selected === "1") {
      this.output.selectedGoodsInfo = {
        itemCode: goodsInfo.itemCode,
        pCode: goodsInfo.pCode,
        classCode: goodsInfo.classCode,
        className: goodsInfo.className,
        buyerCode: goodsInfo.buyerCode,
        buyerName: goodsInfo.buyerName,
        guideGoodsName: goodsInfo.guideGoodsName,
        guideStandardName: goodsInfo.guideStandardName,
        makerName: goodsInfo.makerName,
        payeeClientCode: goodsInfo.payeeClientCode,
        payeeClientKanji: goodsInfo.payeeClientKanji,
        regularRegistDate: goodsInfo.regularRegistDate,
      };
    }
  }

  // ダイアログを閉じる
  private closeWindow(isCanceled = false): void {
    // 自画面を閉じる
    this.closeFunction(isCanceled);
  }

}
